const useAssetsStyles = () => {
    return {
        assetsGridCardStyles: {
            p: 1.5,
        },
        addAssetButtonStyles: {
            width: 36,
            height: 36,
            borderRadius: 500,
            minWidth: 'unset',
        },
    };
};
export default useAssetsStyles;
